/**
 * JSR
 * e_kosik.js
 * JQuery funkce pro stránku košíku e-shopu
 *
 * @package eshop
 *
 * @author Josef Šmíd <josef@skit.cz>
 * @copyright (c) 2007-2026 Josef Šmíd
 * @version 2.6.0
 */

$(document).ready(function()
{
  var root = $( 'input#js_root' ).val();
  //var jazyk_zkr = $('input#js_web_lang_zkr').val();
 
   //liftor 
  
   $( '#d_cena_tr' ).hide();
   $( '#p_cena_tr' ).hide();
   
  
//  $('input[name=komentar]').each(function( index ,obj ) {
//
//     if($(obj).val()!=='')
//     {
//         var puv_kom = $('textarea[name=poznamka]').val();
//         var uprindex = $(obj).attr('data-stul');
//         $('textarea[name=poznamka]').val(puv_kom+' '+uprindex+') '+$('#vlastni_rozmer').val()+': '+$(obj).val());
//
//     }
//  });
    $('input[name=komentar_psc]').each(function( index ,obj ) {

     if($(obj).val()!=='')
     {
         var puv_kom = $('#kosik_psc_kon').val();
         if(puv_kom)puv_kom = puv_kom +':';
         $('#kosik_psc_kon').val( puv_kom + $(obj).val());

     }
  });
  
  
    $('input[name=index_obr]').each(function (index, obj) {

        if ($(obj).val() !== '')
        {
            var id = $(obj).attr('data-id');
            $.ajax({
                url: '/rsadmin/_funkce/eshop_konfigurator_obr.php',
                type: "GET",
                dataType: "html",
                cache: false,
                data: {obr: $(obj).val(), url: 'true', vl: $(obj).attr('data-kom'), tri_d: 1},
                success: function (aData)
                {
                    $(".loading_" + id).hide();
                    $("#index_obr_" + id).attr("src", aData);
                    $("#celek_index_obr_" + id).attr("src", aData);
                    $("#celek_index_obr_" + id).show();
                    $("#index_obr_" + id).show();
                }
            });
        }
    });

    zakazplatba();
    
  //<editor-fold defaultstate="collapsed" desc="Rezervace odpočet">
  if( $( '.rezervace_ok' ).length > 0 ) 
  {  
    $( '.rezervace_ok' ).each(function (index, obj)
    {
      //načte datum a čas
      var datum_cas  = new Date( $( obj ).attr( "data-datum" ) ).getTime();  

      var x = setInterval(function() {  
        var rozdil_time = ( new Date().getTime() - datum_cas ) / 1000;

        if( rozdil_time <= 1200 )
        {
          const result = new Date((1200 - rozdil_time) * 1000)
            .toISOString()
            .slice(14, 19); 

          $( obj ).find( "strong" ).html( result ); 

          $( obj ).removeClass( "hidden" );
        }
        //pokud někdo nechá načtený web a vyprší interval, tak se lišta skryje
        else {
          clearInterval(x);
          $( obj ).removeClass( "rezervace_ok" ).addClass( "rezervace_end" ); 
          $( obj ).html( $( obj ).attr( "data-end" ) );
        }
      }, 1000);//po 1 sekundě
    } );
  }
  //</editor-fold>
  
  //<editor-fold defaultstate="collapsed" desc="Výběr dopravy a platby">

    $('input[name="doprava"]').click(function ()
    {
        EshopNastavDopravuPlatbu($(this));
//    alert($(this).attr('data-types'));
        if ($(this).attr('data-types') != 1)
        {
            $('input[name="zasilkovna"]').prop('checked', false);
            $('#zasilkovna_id_pob').val(null);
        } else
        {
            $('input[name="zasilkovna"]').prop('checked', true);
            $('input[name="zasilkovna"]:checked').click();
            var doprava_zas = $('input[name="doprava"]:checked');
            if (doprava_zas.attr('data-cena') == 0)
            {
                $("#cena_zasilkovna").html('zdarma');
            } else
            {
                $("#cena_zasilkovna").html(doprava_zas.attr('data-cena') + ' Kč');
            }
        }
        $('input[name="doprava"]').parent().parent().removeClass('vybrano_doprava');
        $(this).parent().parent().addClass('vybrano_doprava');
        //zrušení výběru platby při výběru nekompatibilní dopravy
        var platba = $('input[name="platba"]:checked');
        if (platba.length > 0)
        {
            if ($(platba.attr('id')).is(':hidden'))
            {
                $('input[name="platba"]').prop('checked', false);
            }
            
        }
    });

    $('input[name="platba"]').click(function ()
    {  
        EshopNastavDopravuPlatbu($(this));
        if( $( this ).attr( "data-sub" ) === "1" )
        {
          $( '[id^=' + $( this ).attr( "id" ) + '_]' ).prop( "disabled", false );  
          if( $( '[id^=' + $( this ).attr( "id" ) + '_]:checked' ).length === 0 )
          {
            $( '#' + $( this ).attr( "id" ) + "_" + $( this ).attr( "data-sub-vychozi" ) ).prop( 'checked', true );
          } 
        }
        else
        {  
          $( 'input[name="platba_sub"]' ).prop( 'checked', false );
        }

        if ( $('input[name="doprava"]').is(':checked') ===  true && $('input[name="platba"]').is(':checked') ===  true)
        {
          $( '.pokracovat_udaje' ).css('display','table');
        }  
    });
 
    $('input[name="platba_sub"]').click(function ()
    { 
        $( "#" + $( this ).attr( "platba-top" ) ).prop( 'checked', true ).click();
    });

    $('input[name="zasilkovna"]').click(function ()
    {
        if ($(this).is(':checked'))
        {
            $('input[name="doprava"]').each(function (  ) {
                if ($(this).attr('data-types') != 1)
                {
                    $(this).prop('checked', false);
                } else
                {
                    konzasilkovna();
                }

            });
        }
    });

  //</editor-fold>

  //<editor-fold defaultstate="collapsed" desc="Kliknutí na vybranou dopravu po odeslání formuláře">

  var doprava = $('input[name="doprava"]:checked');
  if ( doprava.length > 0 ) doprava.click();

  var platba = $('input[name="platba"]:checked');
  if ( platba.length > 0 )
  {
    platba.click();
//  
  }

  DalsiKrok();

  //</editor-fold>

  //<editor-fold defaultstate="collapsed" desc="Výběr výdejního místa">

//  if ( $('#doprava_zasilkovna').is(':checked') )
//  {
//    var zasilkovna_id = $('input[name=vydejni_misto]').val();
//    setInterval( function()
//    {
//      if ( $('input[name=vydejni_misto]').val() !== zasilkovna_id )
//      {
//        $('input[name=vydejni_misto]').val( 'zasilkovna_' + $('input[name=vydejni_misto]').val() )
//        zasilkovna_id = $('input[name=vydejni_misto]').val();
//      }
//    }, 500 );
//  }


    setInterval( function()
    {
     konzasilkovna();
    }, 500 );



  //</editor-fold>

  //<editor-fold defaultstate="collapsed" desc="Překliknutí firemního nebo soukromého účtu">

  $( '#typ_soukr' ).click( function()
  {
    //$( '.adresa_firma input' ).val( '' );
    $('input[name=dic]').val( null ).change();
    $('input[name=ico]').val( null ).change();
    $('input[name=firma]').val( null ).change();
    $( '.adresa_firma' ).hide();
    $( '.nadpis_udaje_firemni' ).hide();
  });
  $( '#typ_firma' ).click( function()
  {
    $( '.adresa_firma' ).show();
    $( '.nadpis_udaje_firemni' ).show();
    $( 'input[name=ico]' ).select();
  });

  //</editor-fold>

  //<editor-fold defaultstate="collapsed" desc="Načtení údajů firmy z ARESu">

  $( 'input[name=ico]' ).change( function()
  {
    SaveUdaj( $(this) );
 
    if ( $(this).val() === '' || nactiJazykZkr_zeme() !== 'cz' ) return false;
 
    $('#loading').show();
    $('#ares_stav').hide();
    $('#ares_stav').html( '' );
    $('#fakturacni input').attr( 'disabled', true );

    var ico = $(this).val();
    $.ajax({
      url: root + "/rsadmin/_funkce/ares.php",
      contentType: "application/json; charset=utf-8",
      type: "GET",
      dataType: "json",
      data: "ico="+ico,
      cache: false,
      async: false,
      success: function(data)
      {
        if ( data.stav === 'ok' && data.ico === ico )
        { 
          $('input[name=dic]').val( data.dic ).change();
          $('input[name=firma]').val( data.firma ).change();
          $('input[name=adresa]').val( data.adresa ).change();
          $('input[name=mesto]').val( data.mesto ).change();
          $('input[name=psc]').val( data.psc ).change();
          //$('select[name=zeme]').val( data.zeme ).change(); musím zakomentovat, pak to vyvolává tento příkaz zbytečně $( '#zeme' ).change( function()

          $( 'input[name=jmeno]' ).select(); 
        }
        else
        {
          $('#ares_stav').html( data.stav );
          $('#ares_stav').show();
          $( 'input[name=ico]' ).select();
          $('#fakturacni input').attr( 'disabled', false );
        }

        $('#loading').hide();
      }
    });
  });

  //ošetření zadání enter klávesy po načtení iča
  $('input[name=ico]').keypress( function(e)
  {
    var code = e.which; // recommended to use e.which, it's normalized across browsers
    if ( code === 13 )
    {
      $( 'input[name=dic]' ).select();
      //e.preventDefault();
      return false;
    }
  });

  //</editor-fold>

  //<editor-fold defaultstate="collapsed" desc="Ověření DIČ v databázi VIES">

  $( 'input[name=dic]' ).change( function()
  {  
    OverVies( root, /*jazyk_zkr*/nactiJazykZkr_zeme() );
  });

  //ošetření zadání enter klávesy po načtení iča
  $('input[name=dic]').keypress( function(e)
  {
    var code = e.which; // recommended to use e.which, it's normalized across browsers
    if ( code === 13 )
    {
      $( 'input[name=firma]' ).select();
      //e.preventDefault();
      return false;
    }
  });
  


  //</editor-fold>

  //<editor-fold defaultstate="collapsed" desc="Přejetí doporučeného zboží při kliknutí na Zobrazit košík">

  $( '#zobrazit_kosik' ).click( function()
  {
    $('html, body').animate({ scrollTop: $("#kosik_vypis").offset().top }, 2000);
    return false;
  });

  //</editor-fold>

  //<editor-fold defaultstate="collapsed" desc="Zvýšení/snížení množství po kliknutí na +/-">

  $('.mnozstvi_plus_konf').click(function ()
  {
    var form = $(this).parent().parent();
    form.find('img.mnozstvi_loading').show();
    var input = form.find('input.mnozstvi');
    var hodnota = parseInt(input.val());
    
    if (isNaN(hodnota))
      hodnota = 1;
    hodnota = hodnota + 1;
    input.val(hodnota);
//    alert(hodnota);
    form.submit();
    return false;
  });

  $('.mnozstvi_minus_konf').click(function ()
  {
    var zobrazit = new Array();
    if ($(this).attr('data-index'))
    {
      var index_stolu = $(this).attr('data-index');
      $('.mnozstvi').each(function (index, obj)
      {
        if ($(obj).attr('data-index') === index_stolu)
        {
          if (parseInt($(obj).val()) <= 1)
          {
            zobrazit.push(1);
          }
          if (parseInt($(obj).val()) > 1)
          {
            zobrazit.push(2);
          }
        }
      });
    }
    var form = $(this).parent().parent();
    form.find('img.mnozstvi_loading').show();
    var input = form.find('input.mnozstvi');
    var hodnota = parseInt(input.val());
    if (isNaN(hodnota))
      hodnota = 1;
    hodnota = hodnota - 1;
//    console.log(zobrazit);
    if (hodnota <= 0 && jQuery.inArray(1, zobrazit) === -1)
    {
      if (confirm($('#delete_polozku').val())) {
        input.val(hodnota);
        form.submit();
        return false;
      } else {
        form.find('img.mnozstvi_loading').hide();
        return false;
      }
    } else if (jQuery.inArray(1, zobrazit) !== -1)
    {
      if (jQuery.inArray(1, zobrazit) !== -1 && jQuery.inArray(2, zobrazit) !== -1)
      {
        if (confirm($('#delete_cast_stolu').val())) {
          input.val(hodnota);
          form.submit();
          return false;
        } else {
          form.find('img.mnozstvi_loading').hide();
          return false;
        }
      } else if (jQuery.inArray(1, zobrazit) !== -1)
      {
        if (confirm($('#delete_stul').val())) {
          input.val(hodnota);
          form.submit();
          return false;
        } else {
          form.find('img.mnozstvi_loading').hide();
          return false;
        }
      } else
      {
        input.val(hodnota);
        form.submit();
        return false;
      }

    } else
    {
      input.val(hodnota);
      form.submit();
      return false;
    }
  });
  $('input.mnozstvi').change(function ()
  {
    var form = $(this).parent().parent();
    form.find('img.mnozstvi_loading').show();
    var hodnota = parseInt($(this).val());
    if (isNaN(hodnota))
      hodnota = 1;
    if (parseInt(hodnota) <= 0)
    {
      if (confirm($('#delete_polozku').val())) {
        form.submit();
        return false;
      } else {
        form.find('img.mnozstvi_loading').hide();
        return false;
      }
    } else
    {
      form.submit();
      return false;
    }
  });

  $('.odstranit').click(function ()
  {
    if (confirm($('#delete_polozku').val())) {
      return true;
    } else {
      return false;
    }
  });
  //</editor-fold>

  //<editor-fold defaultstate="collapsed" desc="Průběžné ukládání údajů objednávky do session">

$( '#doprava input, #platba input,  .typ_udaju input' ).click( function()
  {
    SaveUdaj( $(this) );
  });
  
  $( '#fakturacni input:not(.noautosave), #fakturacni select, #dodaci input, #dodaci select, #poznamka textarea, #parametr_prodeje input, .prodejni_misto' ).change( function()
  {
    SaveUdaj( $(this) );
  });
  
  $( '#zeme' ).change( function()
  {   
    $('#typ_soukr').click(); 
    location.reload();
  });

  //</editor-fold>

  //<editor-fold defaultstate="collapsed" desc="Kredit">

  //dobití kreditu
  $( '#kredit_text' ).change( function()
  {
    if ( !validateFormKredit($( '#kredit_text' )) ) return false;
//    console.log('aa');

    $.post( root + "/rsadmin/_funkce/eshop.php", { action: "zmena_kreditu", cena: $( this ).val() }, function( data )
    {
      location.reload( true );
    });
  });

  //platba kreditem
  $( '#placeno_kredit' ).change( function()
  {
    var max = Math.min( parseInt($("#eshop_kredit_zustatek").val()), parseInt($("#eshop_k_uhrade").val()));
    if ( parseInt( $(this).val() ) > max ) {
        alert("Maximální volba kreditu je " + max.toString() + " Kč.");
        $(this).val("");
    }
    if ( !$("input[name=platba]").attr( 'checked' )) {
        $("#platbakredit").prop('checked', true);
        $( "#platbakredit" ).trigger( "click" );
    }

    PrepocitejCenuDopravyPlatby();
  });
  $('#placeno_kredit').keyup(function(e)
  {
    if (/\D/g.test(this.value))
    {
      this.value = this.value.replace(/\D/g, '');
    }
  });

  //</editor-fold>

$(document).scroll(function () {
  checkOffset();
});
$('input[name="email"]').change(function() {
  checkemail($(this));
});

$('input[name="doprava"]').click(function() {
//  console.log($('input[name="platba"]').is(':checked'));
  if ( $('input[name="doprava"]').is(':checked') ===  true && $('input[name="platba"]').is(':checked')===  true)
  {
    $( '.pokracovat_udaje' ).css('display','table');
  }
  $( '.vypis_plateb' ).removeClass('hidden');
  
});

$( '.pokracovat_udaje' ).click( function()
{
  DalsiKrok(); 
});
$( '.input_dodani' ).click( function()
{
   $(this).parent().find('.nazev_dodani').show();

});

  //ošetření vícenásobného odeslání formuláře
  var submitButton = null;
  $('form').submit( function(e)
  {
      
    if ( $(this).hasClass( 'already-submitted' ) )
    {
      e.preventDefault();
      return false;
    }
    else
    {
      
      if(!KontrolaFormular())
      {
         return false;
      }  
  
      $(this).addClass( 'already-submitted' );
      if ( submitButton !== null )
      {
        $("#dokoncit").before('<div class="obr_dokoncit_loading"><img class="obr_dokoncit_loading_img" src="/images/loading.gif"/></div>');
        submitButton.addClass('ac_loading');
      }
      submitButton = null;
      return true;
    }
  });

 $('.req_fak').keyup(function(e)
  {
      $( this ).parent().parent().find('.chyba_req').hide();
      $( this ).removeAttr('style');
  });
  $('.chyba_req').click(function() 
  {
      $( this ).hide();
      $( this ).parent().find('input').removeAttr('style');
  });
  $('.upravit_krok').click(function() 
  {
      $(".doprava_vybrano span").empty();
      $(".platba_vybrano span").empty();
      $(".doprava_platba_vybrano").removeAttr('style');
      $('.doprava_platba_h2').removeClass('comlp_kosik');
      $('.doprava_platba_div').css('display', 'inline-block');
      $('.udaje_kosik_div').css('display', 'none');
      $('.upravit_krok').removeAttr('style');
      $('.udaje_kosik_h2').addClass('disabled_kosik');
      $( '.pokracovat_udaje' ).css('display','table');
  });
  
   if ($('body').width() <= 1000)
   {
      $('.kosik_nazev').attr( 'colspan', '2' );
      $('.kosik_nadpis').attr( 'colspan', '6' );
      
   }
   else
   {
      $('.only_tell').remove();
   }
   
    var slider_bx_sluzby = null;
    $( '.sluzba_zjisti_vice' ).click(function()
    {
      var windowWidth = $(window).width();
      var windowHeight = $(window).height();
      $( 'div#sluzba_popis_' + $( this ).attr( "data-id" ) ).dialog({
        width: ( windowWidth <= 600 ? windowWidth - 50 : "60%" ),  
        height: ( windowWidth <= 600 ? windowHeight*0.9 : windowHeight*0.7 ),
        modal: true,
        resizable: true,
        dialogClass: "dialog_web", 
        beforeClose: function () {
          if (slider_bx_sluzby)
              slider_bx_sluzby.destroySlider();
        },
        buttons: {
          Close: function() { 
            $( this ).dialog( "close" );
          }
        }
      });
      
      if( $('#eshop_obrazek_slider_sluzba_' + $( this ).attr( "data-id" )).length > 0 )
      {
        slider_bx_sluzby = $('#eshop_obrazek_slider_sluzba_' + $( this ).attr( "data-id" )).bxSlider({
          mode: 'fade',
          speed: 0,
          infiniteLoop: true,
          controls: true,
          touchEnabled: false
        });
        slider_bx_sluzby.reloadSlider();
      }
      return false;
    });
    $(document).on('click', '.foto_galerie_span .fotka', function ()
    {
      if ($(this).attr('data-slide'))
      {
        var aktual_slide = $(this).attr('data-slide');
        if (slider_bx_sluzby)slider_bx_sluzby.goToSlide(aktual_slide);
      }
    });
    
    $( '.doporucene_prislusenstvi' ).click(function()
    {  
      if( $( this ).hasClass( "hidden" ) ) return false;
      //odeberu z URL mini, aby při obnovení nevyskakovalo okno, jen po vložení
      var url = new URL(window.location);
      url.searchParams.delete('mini');
      window.history.replaceState({}, document.title, url);
      
      $(window).scrollTop( 0 ); 
      var click = $( this );
      var windowWidth = $(window).width();
      var windowHeight = $(window).height();
      var doporucene_prislusenstvi_swiper = null;
    
      $( "#doporucene_prislusenstvi_form" ).dialog({
        width: ( windowWidth <= 600 ? windowWidth - 50 : ( windowWidth >= 1500 ? "1450" : "90%" ) ),
        height: ( windowHeight <= 800 ? windowHeight - 40 : "auto" ), 
        modal: true,
        resizable: true, 
        closeText: "",
        dialogClass: "dialog_web",
          position: { my: "top", at: "top+20" },
        open: function() {
          openDialogScroll();
          $.ajax({
            url: '/rsadmin/_funkce/eshop_kosik_prisl.php',
            type: "GET",
            dataType: "html",
            async: false,
            cache: false, 
            data: { id_p: click.attr( "data-stul" ) },
            success: function (aData) 
            {  
              if (aData)
              { 
                $( "#doporucene_prislusenstvi_form div" ).html( aData );
                doporucene_prislusenstvi_swiper = new Swiper(".products-swiper", {
                  slidesPerView: 3,
                  spaceBetween: 0,
                  loop: false,
                  pagination: {
                    clickable: true,
                  },
                  scrollable: true,
                  navigation: {
                    nextEl: ".swiper-button-next2",
                    prevEl: ".swiper-button-prev2",
                  },
                  mousewheel: {
                    releaseOnEdges: true,
                    sensitivity: 1,
                    forceToAxis: true
                  },
                  scrollbar: {
                    el: '.swiper-scrollbar',
                    draggable: true,
                  },
                  breakpointsInverse: true,
                  breakpoints: {
                    10: {
                      slidesPerView: 1.0,
                      spaceBetween: 10
                    },
                    576: {
                      slidesPerView: 1.0,
                      spaceBetween: 10
                    },
                    767: {
                      slidesPerView: 2.4,
                      spaceBetween: 10
                    },
                    991: {
                      slidesPerView: 2.4,
                      spaceBetween: 15
                    },
                    1200: {
                      slidesPerView: 3.4,
                      spaceBetween: 20
                    },

                    1600: {
                      slidesPerView: 3.5,
                      spaceBetween: 25
                    }
                  }
                });
              }
            },
            error: function (request, status, error) {
              $( "#doporucene_prislusenstvi_form div" ).html( click.attr( "data-chyba" ) );
            }
          });
           
          $( "#doporucene_prislusenstvi_zavrit" ).click(function(){ 
            $("#doporucene_prislusenstvi_form").dialog("close");
          });
        },
        beforeClose: function () {
          //$('body').css('overflow', '');
        },
        buttons: {
          "Zavřít": function () {
            //$('body').css('overflow', '');
            $(this).dialog("close");
          }
        } ,
        close: function() { 
          doporucene_prislusenstvi_swiper.destroy(true, true);
          doporucene_prislusenstvi_swiper = null;
          closeDialogScroll();
        }
      });
      return false;
    });

    //produkt s výběrem v doporučeném příslušenství - první klik na Do košíku zobrazí výběr, druhý produkt vloží
    $( document ).on( "click", "#doporucene_prislusenstvi_form .product-item--s-vyberem input[name='koupit']", function()
    {
      var karta = $( this ).closest( ".product-item" );
      if( karta.hasClass( "product-item--vyber-otevreny" ) ) return true;

      karta.addClass( "product-item--vyber-otevreny" );
      $( this ).val( $( this ).attr( "data-text-pridat" ) );
      return false;
    });

    $( document ).on( "click", "#doporucene_prislusenstvi_form .product-item__vyber-zpet", function()
    {
      var karta = $( this ).closest( ".product-item" );
      var koupit = karta.find( "input[name='koupit']" );

      karta.removeClass( "product-item--vyber-otevreny" );
      koupit.val( koupit.attr( "data-text-koupit" ) );
      return false;
    });

    if( $( "#doporucene_prislusenstvi_form" ).attr( "data-open" ) === "1" )
    {
      $( ".doporucene_prislusenstvi" ).last().click();
    }
});

function nactiJazykZkr_zeme()
{
  if( $( "#zeme option:selected" ).length )
    return $( "#zeme option:selected" ).attr( "data-kod" ).toLowerCase();

  return $('input#js_web_lang_zkr').val();
}

function SaveUdaj( item )
{ 
  var root = $( 'input#js_root' ).val(); 

  var hodnota = item.val();
  if ( item.is(':checkbox') )
  {
    if ( item.attr('checked') ) hodnota = 1;
    else hodnota = 0;
    }
  $.ajax({ url: root + "/rsadmin/_funkce/eshop_vydejni_misto.php", method: 'POST', async: false,
    data: { action: "saveUdaj", nazev: item.attr( 'name' ), udaj: hodnota },
    success: function( data )
    {
      if ( data === "reload" ) location.reload();
      else if ( data === "vies" ) OverVies( root, /*jazyk_zkr*/nactiJazykZkr_zeme() );
    }
  });
}

function checkemail(element)
{
   if(element.val().match(/^[-!#$%&\'*+\\./0-9=?A-Z^_`a-z{|}~]+@[-!#$%&\'*+\\/0-9=?A-Z^_`a-z{|}~]+\.[-!#$%&\'*+\\./0-9=?A-Z^_`a-z{|}~]+$/))
  {
    element.parent().parent().find('.chyba_req_email').hide();
    element.removeAttr('style');
    return true;
  }
  else
  {
    element.parent().parent().find('.chyba_req_email').show();
    element.css('border-color','red');
    return false;
  }
}

function OverVies( root, jazyk_zkr )
{ 
  var item = $('input[name=dic]');

  //úprava hodnoty (neplatné znaky) + doplnění prvních dvou písmen země
  item.val( item.val().trim().replaceAll( " ", "" ).replaceAll( "-", "" ) );
  if ( item.val() && item.val().toLowerCase().substring( 0, 2 ) !== jazyk_zkr ) item.val( jazyk_zkr.toUpperCase() + item.val() );

  SaveUdaj( item );

  $('#loading_vies').show();
  $('#vies_stav').html( '' ).hide();
  var krom = $('#kon_firma').val().split(',');


  if (jQuery.inArray(jazyk_zkr, krom) !== -1 || item.val().toLowerCase().substring( 0, 2 ) === "cz" /*|| item.val() === ""*/ )
  {
    $('#loading_vies').hide();
    $('#fakturacni input').attr( 'disabled', false );
    return false;
  }

  $('#fakturacni input').attr( 'disabled', true );

  var dic = item.val();
  $.ajax({
    url: root + "/rsadmin/_funkce/eshop_vies.php",
    contentType: "application/json; charset=utf-8",
    type: "GET",
    dataType: "json",
    data: "dic="+dic+"&setsession=1",
    cache: false,
    async: false,
    success: function(data)
    {
      if ( data.stav === 'ok' )
      {
        $( 'input[name=firma]' ).select();
        //musím vždy reloadnout, aby se správně načetl režim košíku
        //location.reload();
      }
      else
      {
        $('#vies_stav').html( data.stav ).show();
        $( 'input[name=dic]' ).select();
        //$('#fakturacni input').attr( 'disabled', false );
        //$('#loading_vies').hide();
      }
      //musím vždy reloadnout, aby se správně načetl režim košíku
      location.reload();
    }
  });
  
 
}

function DalsiKrok()
{
   if($('input[name="doprava"]').is(':checked') && $('input[name="platba"]').is(':checked'))
   {
      $(".doprava_vybrano span").append($('input[name="doprava"]:checked').attr('data-popisek'));
      $(".platba_vybrano span").append($('input[name="platba"]:checked').attr('data-popisek'));
      $(".doprava_platba_vybrano").css('display', 'inline-block');
      $('.doprava_platba_h2').addClass('comlp_kosik');
      $('.doprava_platba_div').css('display', 'none');
      $('.udaje_kosik_div').css('display', 'inline-block');
      $('.upravit_krok').css('display', 'flex');
      $('.udaje_kosik_h2').removeClass('disabled_kosik');
      $( '.pokracovat_udaje' ).css('display', 'none');
      
      $([document.documentElement, document.body]).animate({
        scrollTop: $(".udaje_kosik_h2").offset().top - 70
    }, 400);
      
   }
}

function KontrolaFormular()
{
  var chyby = 0;
  $.each( $( '.req_fak' ), function( key, value )
  {
      if($( value ).attr('name') === 'email')
      {
       if( $( value ).val().match(/^[-!#$%&\'*+\\./0-9=?A-Z^_`a-z{|}~]+@[-!#$%&\'*+\\/0-9=?A-Z^_`a-z{|}~]+\.[-!#$%&\'*+\\./0-9=?A-Z^_`a-z{|}~]+$/))
        {}
        else
        {
                $( value ).parent().parent().find('.chyba_req_email').show();
                $( value ).css('border-color','red');
                if(chyby===0)
                {
                   $('html, body').animate({
                               scrollTop: $("input[name="+$( value ).attr('name')+"]").offset().top-120
                              }, 500);
                }   
           chyby++;
        }
      }
     else if($( value ).val().length == 0 || $( value ).val() == 0)
     {
        $( value ).parent().parent().find('.chyba_req').show();
        $( value ).css('border-color','red');
//        console.log(value);
        if(chyby===0)
        {
           $('html, body').animate({
                        scrollTop: $("input[name="+$( value ).attr('name')+"]").offset().top-120
                      }, 500);
        }    

         chyby++;
     }
     else
     {
       $( value ).parent().parent().find('.chyba_req').hide();
       $( value ).removeAttr('style');
     }
  });
  if($('#dod_stejna').is(':checked'))
  {}
  else
  {
    $.each( $( '.req_dod' ), function( key, value )
    {
       if($( value ).val().length == 0 || $( value ).val() == 0)
       {
          $( value ).parent().parent().find('.chyba_req').show();
          $( value ).css('border-color','red');
          chyby++;
       }
       else
       {
         $( value ).parent().parent().find('.chyba_req').hide();
         $( value ).removeAttr('style');
       }
    });
  }
  //console.log(chyby);
  if(chyby === 0) return true;
  else return false;
  
  
}


function validateFormKredit( from )
{
  if ( parseInt($("#eshop_kredit_dobit_min").val(), 10) > parseInt(from.val(), 10))
  {
    alert("Minimální výše dobití kreditu je: " + parseInt($("#eshop_kredit_dobit_min").val(), 10));
    return false;
  }
  else return true;
}

/**
 * Zobrazí nebo skryje formulář pro zadání dodací adresy
 */
function DodaciAdresaDiv( item )
{
  if ( $( item ).prop( 'checked' ) ) $( '#div_dodaci' ).slideUp( 200 );
  else $( '#div_dodaci' ).slideDown( 200 );
}

/**
 * Nastaví zvolený typ dopravy a platby do formuláře a přepočítá ceny
 */
function EshopNastavDopravuPlatbu( item )
{ 
  var cena = item.attr( 'data-cena' );
  var dph = item.attr( 'data-dph' );
  var prefix = item.attr( 'data-typ' );
//  console.log(cena);

  if ( $( item ).is( ':checked' ) )
  {
    $( '.'+prefix+'_nazev' ).html( $( 'label[for="' + $( item ).attr( "id" ) + '"]').html() );
    $( '#'+prefix+'_cena' ).html( UpravFormatCeny(parseFloat(cena)) ).attr( "data-cena", parseFloat(cena) );
    $( '#'+prefix+'_dph' ).val( dph );
    
    $( '#'+prefix+'_cena_tr' ).show();

    PrepocitejCenuDopravyPlatby();
  }
  else
  {
    $( '#'+prefix+'_cena_tr' ).hide();
  }

  //skrytí nekompatibilních typů platby
  if ( prefix === 'd' )
  {
    var skryt_dodaci = item.attr( 'data-vyber' ) === 'true' ? true : false;
    var platby = item.attr( 'data-platby' ).split( ',' );

    $.each( $( 'input[name=platba]' ), function( key, value )
    { 
      if ( in_array( platby, $( value ).val() ) && $( value ).val() !== "bezplatby" )
      {
        $( '.platba'+$( value ).val() ).show(); 
        $( '#platba'+$( value ).val() ).prop('disabled', false);
        $( '#platba'+$( value ).val() ).parent().parent().removeAttr("style");
        $( '.vypis_plateb' ).removeClass('hidden');
        if( $( '#platba'+$( value ).val() ).attr( "data-sub" ) === "1" )
        { 
          $( '[id^=' + $( this ).attr( "id" ) + ']' ).prop( "disabled", false );
          $( '[id^=' + $( this ).attr( "id" ) + ']' ).parent().parent().removeAttr("style");
        }
      }
      else if ( !$( '#platba'+$( value ).val() ).hasClass('onlineplatba') )
      {
//        console.log('#platba'+$( value ).val());
        $( '.platba'+$( value ).val() ).hide();
        $( '#platba'+$( value ).val() ).prop('checked', false);
        $( '#platba'+$( value ).val() ).prop('disabled', true);
        $( '#platba'+$( value ).val() ).parent().parent().css("color", "#a1b1c8");
        $( '#platba'+$( value ).val() ).parent().parent().css("cursor", "default");
        $( '#platba'+$( value ).val() ).parent().parent().css("pointer-events", "none"); 
        if( $( '#platba'+$( value ).val() ).attr( "data-sub" ) === "1" )
        {  
          $( '[id^=' + $( this ).attr( "id" ) + ']' ).prop( "disabled", true );
          $( '[id^=' + $( this ).attr( "id" ) + ']' ).prop( 'checked', false );
          $( '[id^=' + $( this ).attr( "id" ) + ']' ).parent().parent().css("color", "#a1b1c8");
          $( '[id^=' + $( this ).attr( "id" ) + ']' ).parent().parent().css("cursor", "default");
          $( '[id^=' + $( this ).attr( "id" ) + ']' ).parent().parent().css("pointer-events", "none"); 
        }
      }
       
      zakazplatba();//toto vy se mohlo volat až na konci po each
    });
    //zde projdu pokud je cena rovna nule všechny platby. Pokud rovno nule, tak skryji všechny zobrazím bezplatby (mělo by stačit jim dát jen hide) 
    
    if( parseFloat( $( '#eshop_k_uhrade' ).val() ) === 0 )
    { 
      $.each( $( 'input[name=platba]' ), function( key, value )
      {
        if( $( value ).val() !== "bezplatby" )
        {
          $( '.platba'+$( value ).val() ).hide();
          $( '#platba'+$( value ).val() ).prop('checked', false);
          $( '#platba'+$( value ).val() ).prop('disabled', true);
          $( '#platba'+$( value ).val() ).parent().parent().css("color", "#a1b1c8");
          $( '#platba'+$( value ).val() ).parent().parent().css("cursor", "default");
          $( '#platba'+$( value ).val() ).parent().parent().css("pointer-events", "none"); 
        }
        else
        {
          $( '.platba'+$( value ).val() ).show(); 
          $( '#platba'+$( value ).val() ).prop('disabled', false);
          $( '#platba'+$( value ).val() ).parent().parent().removeAttr("style");
          $( '.vypis_plateb' ).removeClass('hidden');
          $( '.platba'+$( value ).val() ).click();
        }
      });
    }
    
    //případné skrytí/zobrazení dodací adresy
    if ( skryt_dodaci === true )
    {
      $( '#dod_stejna' ).prop( 'checked', true );
      $( '#div_dodaci, #dodaci_stejna' ).hide();
    }
    else
    {
      //if ( !$( '#dod_stejna' ).is( ':checked' ) ) $( '#dod_stejna' ).click();
      $( '#dodaci_stejna' ).show();
    }
  } 
}

function in_array( haystack, needle )
{
  var length = haystack.length;
  for( var i = 0; i < length; i++ )
  {
    if( haystack[i] == needle ) return true;
  }
  return false;
}

/**
 * Na základě zvolené platby a dopravy přepočítá celkovou cenu
 */
function PrepocitejCenuDopravyPlatby()
{
  var cena_bez_dph = parseFloat( $( '#cena_bez_dph' ).val() );
  var dph = parseFloat( $( '#dph' ).val() );
  var celkem = parseFloat( $( '#celkem' ).val() );
  var vouchery = parseFloat( $( '#vouchery' ).val() );

  var d_dph = parseFloat( $( '#d_dph' ).val() );
  if ( isNaN( d_dph ) ) d_dph = 0;
  var p_dph = parseFloat( $( '#p_dph' ).val() );
  if ( isNaN( p_dph ) ) p_dph = 0;

  var d_cena = parseFloat( $( '#d_cena' ).attr( "data-cena" ) );
  if ( isNaN( d_cena ) ) d_cena = 0;
  var p_cena = parseFloat( $( '#p_cena' ).attr( "data-cena" ) );
  if ( isNaN( p_cena ) ) p_cena = 0;

//  console.log(p_cena);

  var p_kredit = parseFloat( $( '#placeno_kredit' ).val() );
  if ( isNaN( p_kredit ) ) p_kredit = 0;

  var d_bez_dph = $('#eshop_kosik_rezim_dph').val() === "1" ? d_cena : SpocitejCenuBezDph( d_cena, d_dph );
  var p_bez_dph = $('#eshop_kosik_rezim_dph').val() === "1" ? p_cena : SpocitejCenuBezDph( p_cena, p_dph );

  cena_bez_dph = cena_bez_dph + d_bez_dph + p_bez_dph;
  celkem = celkem + d_cena + p_cena;
  dph = celkem - vouchery - cena_bez_dph;

  if ( p_kredit > 0 && ( celkem - p_kredit ) <= 0 )
  {
    $("#tr_eshop_kreditni_system").removeClass( "hidden" );
    if ( celkem - p_kredit < 0 )
    {
      p_kredit = p_kredit - p_kredit - celkem;
      $( '#placeno_kredit' ).val( p_kredit );
    }
  }
  else
  {
    $( "#tr_eshop_kreditni_system" ).addClass( "hidden" );
    $( "#platbakredit" ).prop( 'checked', false );
  }

  $( '.cena_bez_dph' ).html( UpravFormatCeny( cena_bez_dph ) );
  $( '.dph' ).html( UpravFormatCeny( dph ) );
  $( '.cena_celkem' ).html( UpravFormatCeny( celkem - p_kredit ) );
  $( '#eshop_k_uhrade' ).val( ( celkem ) );
}

/**
 * Vypočítá cenu bez DPH
 */
function SpocitejCenuBezDph( cena_vcetne_dph, procento_dph )
{
  return cena_vcetne_dph / ( 1 + ( procento_dph / 100 ) );
}

/**
 * Upraví formát ceny dle nastavení e-shopu
 */
function UpravFormatCeny( cena )
{
  var mena_pred = $( '#eshop_mena_pred' ).val().replace( ' ', '&nbsp;' );
  var mena_za = $( '#eshop_mena_za' ).val().replace( ' ', '&nbsp;' );
  var zaokr = parseInt( $( '#eshop_zaokr' ).val() );
  if ( isNaN( zaokr ) ) zaokr = 0;
  var des_mist = parseInt( $( '#eshop_des_mist' ).val() );
  if ( isNaN( des_mist ) ) des_mist = 0;

  cena = cena.toFixed( zaokr );
  cena = parseFloat( cena ).toFixed( des_mist );

  cena_string = thousandSeparator( cena );
  cena_string = mena_pred + cena_string + mena_za;
  cena_string = cena_string.replace( '.', ',' );

  return cena_string;
}

/**
 * Funkce pro oddělení tisíců v čísle
 */
function thousandSeparator( n, sep )
{
	var sRegExp = new RegExp( '(-?[0-9]+)([0-9]{3})' ),
	sValue = n+'';

	if ( sep === undefined ) sep = ' ';
	while ( sRegExp.test( sValue ) ) sValue = sValue.replace( sRegExp, '$1'+sep+'$2' );
	return sValue;
}

function konzasilkovna()
{
    if ( $('#doprava_zasilkovna').is(':checked') )
    {
//        alert($('input[name=vydejni_misto]').val());
      var root = $( 'input#js_root' ).val();
      var zasilkovna_id = $('input[name=vydejni_misto]').val();
      if ( $('#zasilkovna_id_pob').val() !== zasilkovna_id )
      {
        $('#zasilkovna_id_pob').val(zasilkovna_id);
        $.ajax({
            url: root + "/rsadmin/_funkce/eshop_vyber_prodejnu.php",
            contentType: "application/json; charset=utf-8",
            type: "GET",
            dataType: "json",
            data: "idp="+zasilkovna_id,
            cache: false,
            success: function(data)
            {
                $("#doprava_zasilkovna_"+data.zeme+"").prop( 'checked', true );
                var doprava_zas = $('input[name="doprava"]:checked');
                doprava_zas.click();
                doprava_zas.change();
                if(doprava_zas.attr('data-cena') == 0)
                {
                    $("#cena_zasilkovna").html('zdarma');
                }
                else
                {
                    $("#cena_zasilkovna").html(doprava_zas.attr('data-cena')+' Kč');
                }
            }
          });
      }
  }
}
function OpenCloseVoucher()
{
  if ( $('#voucher_div').hasClass('open_voucher') ) 
  {
    $('#voucher_div').removeClass('open_voucher');
    $('#open_button').removeClass('open_voucher_p');
    $('#voucher_div').slideUp( 200 );
  }
  else
  {
    $('#voucher_div').addClass('open_voucher');
    $('#open_button').addClass('open_voucher_p');
    $('#voucher_div').slideDown( 200 );
  }
}
//funkce pro pohyb stolu v konfigurátoru je na PC
function checkOffset() {

  if ($('body').width() > 1024)
  {
      if ($('.kosik_prava_cast').offset().top + $('.kosik_prava_cast').height() >= $('#zapati').offset().top)
      {
      if ($('#zapati').offset().top - $('.kosik_prava_cast').height() > 100)
        {
//          console.log(parseInt($('.kosik_prava_cast').css('margin-top')));
   
          $('.kosik_prava_cast').css('top', $('#zapati').offset().top - $('.kosik_prava_cast').height() - parseInt($('.kosik_prava_cast').css('margin-top')) - 150);
          $('.kosik_prava_cast').css('position', 'absolute');
      } else
        {
          $('.kosik_prava_cast').css('position', 'relative'); // restore when you scroll up
          $(".kosik_prava_cast").css('top', '');
        }
      }
      if ($(document).scrollTop() + window.innerHeight < $('#zapati').offset().top)
      {
        $('.kosik_prava_cast').css('position', 'fixed'); // restore when you scroll up
        $(".kosik_prava_cast").css('top', '');
      
      }
    
}
}
function zakazplatba() { 
 $('input[name=platba_zakaz]').each(function( index ,obj )
  {
    if($(obj).val()!=='')
    {
        var zakaz_hod = $(obj).val();
        var zakaz_hod_array = zakaz_hod.split(',');
        $('input[name=id_produktu_eshop]').each(function( index_id ,obj_id ) { 
           if($(obj_id).val()!=='')
           {  
                if(jQuery.inArray($(obj_id).val(), zakaz_hod_array) !== -1)
                {  
                    $("#"+$(obj).attr('data-deac')).prop("disabled", true);
                    $("#"+$(obj).attr('data-deac')).prop('checked', false);
                    $("#"+$(obj).attr('data-deac')).parent().parent().css("color", "#a1b1c8");
                    $("#"+$(obj).attr('data-deac')).parent().parent().css("cursor", "default");
                    $("#"+$(obj).attr('data-deac')).parent().parent().css("pointer-events", "none"); 
                    
                    $(".doprava_na_db").removeAttr("style");
                    $(".doprava_na_db").css("display", "table"); 
                    $("#block_doprava").empty();
                    $("#block_doprava").append($("#zakaz_dobirka").val());
                }
           }
        });
    }
});
}